<template>
  <div
    class="circle-base"
    :style="{ width: `${circleSize}px`, height: `${circleSize}px` }"
  >
    <lazy-img :src="bgImage" class="circle-base__image" />
    <div class="circle-base__content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import {assetsDir} from '@/data/steps';

export default {
  data() {
    return {
      bgImage: `${assetsDir}/bg-gradient.jpg`
    }
  },
  computed: {
    circleSize() {
      return this.$store.getters.circleSize;
    },
  },
};
</script>

<style lang="scss">
.circle-base {
  position: relative;
  background-color: $brownMedium;
  background-size: cover;
  background-position: center;
  border-radius: 50%;
  border: 7px solid white;
  margin-left: auto;
  margin-right: auto;

  overflow: hidden;
  pointer-events: none;
  z-index: 0;
}

.circle-base__content {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: block;

  border-radius: inherit;
  pointer-events: auto;
  overflow: hidden;

}

.circle-base__content--shadow {
  &::after {
    content: '';
    display: block;
    position: absolute;

    bottom: 0;
    left: 0;
    right: 0;
    overflow: hidden;
    height: 250px;

    background: linear-gradient(
        20deg,
        $brownMedium 35%,
        rgba($brownMedium, 0) 65%
      ),
      linear-gradient(-20deg, $brownMedium 35%, rgba($brownMedium, 0) 65%);
    z-index: 0;

    pointer-events: none;
  }

  & > * {
    box-sizing: border-box;
  }
}

// circle-content block
.circle-content {
  position: relative;
  width: 100%;
  height: 100%;
  box-sizing: border-box;

  padding: 40px 10px 60px;

  font-size: 7.6px;
  color: white;

  &:not(:focus):hover {
    .circle-content__image--hover {
      opacity: 1;
    }
  }
}

img.circle-content__image {
  pointer-events: none;
}

img.circle-content__image--hover {
  opacity: 0;
  transition: 300ms ease-in-out;

  &.circle-content__image--active {
    opacity: 1;
  }
}

.circle-content--default {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-wrap: wrap;
  flex-direction: column;
  text-align: center;
}

.circle-content--inner-circle {
  &::before {
    content: '';
    position: absolute;
    top: calc(10% - 4px);
    width: 80%;
    height: 80%;
    overflow: hidden;

    border: 2px solid white;
    border-radius: 50%;

    transform-origin: 50% 50%;

    pointer-events: none;
  }
}

.circle-content__title {
  font-family: $titleFont;
  font-size: 7em;
  line-height: 1;
  font-weight: normal;
  letter-spacing: 1px;
  color: currentColor;
}

.circle-content__pre-title,
.circle-content__title,
.circle-content__description {
  z-index: 1;
}

.circle-content__pre-title,
.circle-content__description {
  font-family: $textFont;
  font-size: 1.5em;
  letter-spacing: 1px;
  margin-top: 0.5em;

  color: currentColor;
  line-height: 1.4;
  font-weight: normal;
  text-transform: uppercase;
}

.circle-content__pre-title {
  font-size: 1.25em;
}

// circle-single block
.circle-single {
  position: relative;
  width: 100%;
  height: 100%;

  display: flex;
  justify-content: center;
  align-items: flex-end;

  .circle-content {
    flex-basis: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    transition: color 300ms ease-in;
  }
}

// circle-double block
.circle-double {
  position: relative;
  width: 100%;
  height: 100%;

  display: flex;
  justify-content: space-between;
  align-items: stretch;

  &::after {
    content: '';
    position: absolute;
    display: block;
    pointer-events: none;
    width: 8px;
    height: 100%;
    background-color: white;
    left: 50%;
    top: 0;
    transform: translateX(-4px);
  }

  .circle-content {
    flex-basis: 50%;
    display: flex;
    flex-direction: column;
    justify-content: flex-end;
    transition: color 300ms ease-in;
    cursor: pointer;

    &:hover {
      color: $brownDark;
    }

    &:first-child {
      align-items: flex-end;
      text-align: right;
      border-right: 3px solid white;
    }

    &:last-child {
      align-items: flex-start;
      text-align: left;
      border-left: 3px solid white;
    }
  }
}

@media (max-width: 390px) {
  .circle-content {
    font-size: 1.2vw;
  }

}

@media (max-width: 460px) {
  .circle-content {
    font-size: 1.6vw;
  }

  .circle-base__content--shadow {
    &::after {
      height: 200px;
    }
  }
}

@media (min-width: 460.89px) {
  .circle-base {
    border-width: 14.5px;
  }

  .circle-content {
    &:first-child {
      border-right-width: 7px;
    }

    &:last-child {
      border-left-width: 7px;
    }
  }

  .circle-content--inner-circle {
    &::before {
      border-width: 4px;
    }
  }
}

@media (min-width: 992.89px) {
  .circle-content {
    font-size: 9px;
    padding: 80px 20px 90px;
  }
}
</style>
